import { useEffect } from 'react';
import { BackHandler } from 'react-native';
import { isWeb } from 'utils/deviceUtils';

const useBackButton = (handler: () => boolean | null | undefined) => {
  useEffect(() => {
    let subscription = null;
    if (!isWeb) {
      subscription = BackHandler.addEventListener('hardwareBackPress', handler);
    }
    return () => {
      if (!isWeb) {
        subscription?.remove();
      }
    };
  }, [handler]);
};

export default useBackButton;
